module.exports = __webpack_public_path__ + "img/corsi_online_risposte_smartform.4cec8ab2.png";